import { render } from "./ThemePicker.vue?vue&type=template&id=79f098ab&ts=true"
import script from "./ThemePicker.vue?vue&type=script&lang=ts"
export * from "./ThemePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__